import React from 'react'
import { MenuLink } from '@src/modules/Layout/shared/MenuLink'
import { BULLETINS_ROUTES } from '../../constants'
import { Icon } from '@therms/atalaya'
import { MdDashboard } from 'react-icons/md'

function BulletinsMenuLink() {
  return (
    <MenuLink to={BULLETINS_ROUTES.__ROOT__}>
      <div className="flex w-full items-center space-x-xs">
        <Icon Icon={MdDashboard} />

        <span className="grow">Bulletins</span>
      </div>
    </MenuLink>
  )
}

export { BulletinsMenuLink }
